import { api } from '@/lib/api';
import { tipoUsuarioGuard } from '@/lib/permissions';
import { createFileRoute } from '@tanstack/react-router';
import AlterarDados from './-component';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/web/$codigo/alterar-dados/',
)({
  context: ctx => ({
    dadosBancoQueryOptions: api.queryOptions(
      'get',
      '/clientes/servicos-web/{codigo}/dados-banco',
      {
        params: { path: { codigo: ctx.params.codigo } },
      },
    ),
  }),
  beforeLoad: async () => {
    await tipoUsuarioGuard('Admin');
  },
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.dadosBancoQueryOptions);
  },
  component: AlterarDados,
});
